// frontend/config/index.js
import app, { db, auth, storage, analyticsPromise, firebaseConfig } from "./firebaseConfig";

console.log("Frontend initialized");

analyticsPromise.then((analytics) => {
  if (analytics) console.log("Firebase Analytics inicializado");
  else console.log("Analytics no soportado (entorno no navegador o falta configuración)");
});

export { app, db, auth, storage, analyticsPromise, firebaseConfig };